import Residencia from './residencia'
export default class Especialidade {
    constructor(nome, residencia) {
      this.nome = nome;
      this.residencia = new Residencia(residencia.idResidencia, residencia.nome, residencia.status)
    }
  }